import entity from '../../entities/billing/entity';

export const TYPES = {
  GET_CREDIT_CARD_SUMMARY_ERROR: 'billings/GET_CREDIT_CARD_SUMMARY_ERROR',
  GET_CREDIT_CARD_SUMMARY_SUCCESS: 'billings/GET_CREDIT_CARD_SUMMARY_SUCCESS',
  GET_CREDIT_CARD_SUMMARY: 'billings/GET_CREDIT_CARD_SUMMARY',
};

export const getCreditCardSummary = organizationId => async (dispatch) => {
  dispatch({ type: TYPES.GET_CREDIT_CARD_SUMMARY });
  try {
    const response = await entity.api.getCreditCardSummary(organizationId);
    const payload = response;
    dispatch({ type: TYPES.GET_CREDIT_CARD_SUMMARY_SUCCESS, payload });
  } catch (error) {
    dispatch({ type: TYPES.GET_CREDIT_CARD_SUMMARY_ERROR, payload: error });
  }
};

export default {
  TYPES,
  getCreditCardSummary,
};
